export default [
    {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
        path: '/main',
        redirect: '/',
        component: () => import('@/layouts/Main.vue'),
        children: [
            {
              path: '/',
              name: 'dashboard',
              component: () => import('@views/Dashboard.vue'),
              meta: {
                title: 'Dashboard',
                authRequired: true,
              }
            },
            {
              path: '/notifications',
              name: 'notifications',
              component: () => import('@views/notifications/NotificationList.vue'),
              meta: {
                title: "Notifications",
                authRequired: true,
              }
            },
            {
              path: '/examinations/:invitationId(\\d+)',
              name: 'examination-show',
              component: () => import('@views/examinations/ExaminationShow.vue'),
              meta: {
                title: "View Examination",
                authRequired: true,
              },
            },
            {
                path: "/exam-sessions/:sessionId([0-9a-fA-F-]+)",
                name: "exam-session-view",
                component: () => import("@views/exam-sessions/ExamSessionShow.vue"),
                meta: {
                    title: "View Exam Session",
                    authRequired: true,
                },
            },
            {
              path: '/account',
              name: 'account',
              component: () => import('@views/account/UserAccount.vue'),
              meta: {
                title: 'Profile',
                authRequired: true,
              },
            }
        ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
        path: '/full',
        component: () => import('@/layouts/Full.vue'),
        children: [
          {
            path: '/login',
            name: 'login',
            component: () => import('@/views/pages/Login.vue'),
            meta: {
              guestRequired: true,
              title: "Login"
            }
          },
          {
              path: '/error-404',
              name: 'error-404',
              component: () => import('@/views/pages/Error404.vue'),
              meta: {
                title: "404 - Page not Found"
              }
          },
          {
              path: '/error-500',
              name: 'error-500',
              component: () => import('@/views/pages/Error500.vue'),
              meta: {
                title: "500 - Server error"
              }
          },
        ]
    },
    // Redirect to 404 page, if no match found
    {
        path: '/:any(.*)',
        redirect: '/error-404'
    },

]